export default [
  {
    path: '/personnel-evaluation-master-list',
    name: 'personnel-evaluation-master-list',
    component: () => import(
      '@/views/personnel-evaluation/personnel-list/PersonnelEvaluationMasterList.vue'
    ),
    meta: {
      // GulfTIC's own staff. Contracted inspectors live in the external list below, so this one
      // no longer mixes the two.
      employment: 'internal',
      title: 'Personnel Evaluation Master List ',
      requiresAuth: true,
      action: 'browes',
      resource: 'Personnel Evaluation Master List',
      pageTitle: 'Personnel Evaluation Master List',
      breadcrumb: [
        {
          text: 'Personnel Evaluation Master List',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  {
    // Externally contracted inspectors get their own section. Same component and same endpoint —
    // only `employment` differs, so the two lists cannot drift apart. The split is by
    // users.is_internal_employee, not by role: several contracted inspectors hold 'engineer'.
    path: '/personnel-evaluation-external',
    name: 'personnel-evaluation-external',
    component: () => import(
      '@/views/personnel-evaluation/personnel-list/PersonnelEvaluationMasterList.vue'
    ),
    meta: {
      employment: 'external',
      // Karim, 13 Sep: rename the tab from "External Evaluation" to "Inspectors Evaluations".
      // Route name/path/resource are untouched on purpose — only the visible label changes.
      title: 'Inspectors Evaluations',
      requiresAuth: true,
      action: 'browes',
      resource: 'Personnel Evaluation Master List',
      pageTitle: 'Inspectors Evaluations',
      breadcrumb: [
        {
          text: 'Inspectors Evaluations',
        },
        {
          text: 'List',
          active: true,
        },
      ],
    },
  },
  // {
  //   path: '/personnel-evaluation-open',
  //   name: 'personnel-evaluation-open',
  //   component: () => import(
  //     '@/views/personnel-evaluation/personnel-list/PersonnelEvaluationOpen.vue'
  //   ),
  //   meta: {
  //     title: 'Open Evaluation',
  //     requiresAuth: true,
  //     action: 'browes',
  //     resource: 'Open Evaluation',
  //     pageTitle: 'Open Evaluation ',
  //     breadcrumb: [
  //       {
  //         text: 'Personnel Evaluation',
  //       },
  //       {
  //         text: 'List',
  //         active: true,
  //       },
  //     ],
  //   },
  // },
  {
    path: '/start-new-personnel-evaluation',
    name: 'start-new-personnel-evaluation',
    component: () => import(
      '@/views/personnel-evaluation/personnel-action/StartNewEvaluation.vue'
    ),
    meta: {
      title: 'Start New Personnel Evaluation ',
      requiresAuth: true,
      action: 'browes',
      resource: 'Start New Personnel Evaluation',
      pageTitle: 'Start New Personnel Evaluation',
      breadcrumb: [
        {
          text: 'Personnel Evaluation Master List',
          to: '/personnel-evaluation-master-list',
        },
        {
          text: 'Start New Personnel Evaluation',
        },
        {
          text: 'add',
          active: true,
        },
      ],
    },
  },
  {
    path: '/user-personnel-evaluation/:id/:ccId',
    name: 'user-personnel-evaluation',
    component: () => import('@/views/personnel-evaluation/personnel-list/PersonnelUser.vue'),
    meta: {
      title: 'User Personnel Evaluation ',
      requiresAuth: true,
      action: 'browes',
      resource: 'User Personnel Evaluation',
      pageTitle: 'User Personnel Evaluation',
      breadcrumb: [
        {
          text: 'Personnel Evaluation Master List',
          to: '/personnel-evaluation-master-list',
        },
        {
          text: 'User Personnel Evaluation',
        },
        {
          text: 'View',
          active: true,
        },
      ],
    },
  },
  {
    path: '/personnel-details/:id/:user_id',
    name: 'personnel-details',
    component: () => import(
      '@/views/personnel-evaluation/personnel-list/PersonnelDetails.vue'
    ),
    meta: {
      title: 'Personnel Evaluation ',
      requiresAuth: true,
      action: 'browes',
      resource: ' Personnel Evaluation',
      pageTitle: 'Personnel Evaluation',
      breadcrumb: [
        {
          text: 'Personnel Evaluation Master List',
          to: '/personnel-evaluation-master-list',
        },
        {
          text: 'Personnel Evaluation Details',
        },
        {
          text: 'Show',
          active: true,
        },
      ],
    },
  },
]
